<!-- Date-range picker -->
<div class="datepicker-class" [class.nova-open-upward]="openUpward">
  <div class="row mt-3 mb-3">

    <div class="col-4 datepicker-trigger-row" style="display: flex; flex-direction: row; position: relative;"
      [class.nova-trigger-wrapper]="openUpward"
      (click)="onTriggerClick($event)">
      <div *ngIf="!showFilterUI;else filterUI" class="button-wrapper" [ngStyle]="{ 'width': divWidthTop }">
        <app-button iconUrl="assets/icons/date_range.svg" (onButtonClick)="toggleDropdown()"
          [buttonText]="getDateLabel()" [clicked]="_dropdownOpened()"></app-button>
      </div>
      <ng-template #filterUI>
        <div class="single-date-wrapper" (click)="handleButtonClick($event)">
          <div class="single-date-label">{{selectedDate | truncate: 22}}</div>
          <img src="assets/icons/date_range.svg" alt="">
        </div>
      </ng-template>
      <input #datePickerInput [ngStyle]="{ 'width': divWidthBottom }" class="rangepicker-input date-picker-input" type="text" [id]="id"
        readonly ngxDaterangepickerBootstrap [(ngModel)]="selectedRangeCalendarAutoLeft"
        [drops]="openUpward ? dropsUp : dropsDown" [opens]="opensLeft" [locale]="locale" [ranges]="ranges"
        [showCustomRangeLabel]="!showFilterUI" [showCancel]="true" [linkedCalendars]="true" [alwaysShowCalendars]="true"
        [showRangeLabelOnInput]="false" [keepCalendarOpeningWithRange]="true" [closeOnAutoApply]="false" [autoApply]="!showFilterUI" [isTooltipDate]="isTooltipDate" [isCustomDate]="isCustomDates"
        [isInvalidDate]="isInvalidDate" (datesUpdated)="datesUpdatedRange($event)"
        (ngModelChange)="datesUpdatedRange($event); loadFetchFunctions()" [singleDatePicker]="singleDatePicker"
        [appOutSideClickDisabled]="showFilterUI" appOutSideClick (outSideClick)="handleOutSideClick()" aria-describedby="rangeCalendarAutoRightDesc" />
    </div>
  </div>
</div>
